import type { ButtonHTMLAttributes } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost';
  block?: boolean;
  busy?: boolean;
}

export function Button({
  variant = 'primary',
  block = false,
  busy = false,
  className,
  children,
  disabled,
  type = 'button',
  ...rest
}: ButtonProps) {
  const classes = ['btn', `btn--${variant}`, block ? 'btn--block' : '', className ?? ''].join(' ');
  return (
    <button type={type} className={classes} disabled={disabled ?? busy} aria-busy={busy} {...rest}>
      {children}
    </button>
  );
}
